<template>
  <div class="footer-nav">
    <div class="nav-item" v-for="(t,i) in data" :key="i" @click="$router.push(t.path)">
      <div>
        <div class="icon">
          <i class="iconfont" :class="t.icon"></i>
        </div>
      </div>
      <div class="text">{{t.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [
        {
          name: '首页',
          icon: 'iconhome',
          path: '/nav-menu'
        },
        {
          name: '项目',
          icon: 'iconwork-order',
          path: '/statistics-project'
        },
        {
          name: '报销统计',
          icon: 'iconshenqingbaoxiao',
          path: '/statistics-apply'
        },
        {
          name: '日志管理',
          icon: 'icongongshishezhi',
          path: '/fill-record-mobile'
        },
      ]
    }
  },


}
</script>

<style lang="scss" scoped>
.footer-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 50px;
  background: #123571;
  .nav-item {
    flex: 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #2d81d3;
    &:last-child {
      border-right: none;
    }
    .icon {
      .iconfont {
        color: #ffffff;
        font-size: 20px;
      }
    }
    .text {
      color: #ffffff;
      font-size: 12px;
    }
  }
}
</style>